import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b8b27d2c")

_pushScopeId("data-v-b8b27d2c")
const _hoisted_1 = { class: "auth" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { for: "email" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "psw" }, [
  /*#__PURE__*/_createVNode("b", null, "Password")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("button", null, "Login", -1)
const _hoisted_6 = {
  key: 0,
  class: "failedLogin"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("p", null, _toDisplayString(_ctx.$t('authWidget.loginMsg')), 1),
        _createVNode("label", _hoisted_3, [
          _createVNode("b", null, _toDisplayString(_ctx.$t('authWidget.login')), 1)
        ]),
        _withDirectives(_createVNode("input", {
          type: "text",
          placeholder: "Enter Login",
          name: "login",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.login = $event))
        }, null, 512), [
          [_vModelText, _ctx.login]
        ]),
        _hoisted_4,
        _withDirectives(_createVNode("input", {
          type: "password",
          placeholder: "Enter Password",
          name: "psw",
          required: "",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.pass = $event))
        }, null, 512), [
          [_vModelText, _ctx.pass]
        ]),
        _hoisted_5
      ]),
      (_ctx.loginFailed)
        ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('authWidget.loginFailed')), 1))
        : _createCommentVNode("", true)
    ], 32)
  ]))
})